// src/router/index.js

import Vue from "vue";
import VueRouter from "vue-router";
import ProductDetail from "@/components/ProductDetail.vue";
import Success from "@/components/Success.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/success/",
    name: "Success",
    component: Success,
  },
  {
    path: "/:sku",
    name: "ProductDetail",
    component: ProductDetail,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
